exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  z-index: 500; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/toolbar/toolbar-alpha/toolbar-alpha.component.scss
// module id = ../../../../../src/app/core/toolbar/toolbar-alpha/toolbar-alpha.component.scss
// module chunks = main